<template>
  <div>
    <div class="left">
      <el-tree :highlight-current='true' ref="ftree" :props="props" :load="loadNode" @node-click="listClick"
        :expand-on-click-node="false" lazy>
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <el-tooltip :content="node.label" placement="right-end">
            <span v-if="data.actived == 1" style="color: #272727;">{{ node.label }}</span>
            <span v-else style="color: #c0c4cc;">{{ node.label }}</span>
          </el-tooltip>
          <span v-if="data.sysDefault != 1">
            <el-button type="text" size="mini" @click="append(data, node)"
              v-if="node.level === 2 && data.classesId !== 90101 && data.classesId !== 90201">
              <i class="el-icon-plus" style="border: 1px solid #000;"></i>
            </el-button>
            <el-button type="text" size="mini" @click="delSubCls(data, node)"
              v-if="node.level === 3 && data.subClsesId !== 9010101 && data.subClsesId !== 9020101">
              <i class="el-icon-delete"></i>
            </el-button>
          </span>
        </span>
      </el-tree>
    </div>

    <div class="line-1"></div>
    <div class="center" v-show="center_page" style="background:#fff">
      <ul class="content-title">
        <li @click="tabClick(item, index)" :class="{ active: index == num }" v-for="(item, index) in tab_all_id"
          :key="index">
          {{ item.name }}
        </li>
      </ul>
      <div style="height: 2px;background: #ebebeb;"></div>
      <div class="basic-info" v-show="base_info">
        <div style="height: 30px;">
          <el-button type="primary" size="mini" style="float: right;margin-right: 10px;margin-top: 10px;"
            @click="editInfo" v-if="edit_base_info">{{ $t('message.button.edit') }}</el-button>
          <el-button size="mini" style="float: right;margin-right: 10px;margin-top: 10px;" @click="closeInfo"
            v-if="!edit_base_info">{{ $t('message.button.cancel') }}</el-button>
          <el-button type="success" size="mini" style="float: right;margin-right: 10px;margin-top: 10px;"
            @click="submitForm" v-if="!edit_base_info">{{ $t('message.button.save') }}</el-button>
        </div>
        <ul v-if="show_base_info" style="position: relative;overflow: hidden;list-style: none;width: 100%;padding: 0;">
          <li v-for="item in base_view_data" style="width: 100%;" :key="item.index">
            <div class="table-list" v-if="item.disabled">
              <!-- <div class="table-list" v-if="autoNumberShow" > -->
              <span class="list-key-1">{{ item.name }}</span>
              <span style="display: inline-block;margin: 0 6px;">:</span>
              <span class="list-val" :title="item.val">{{ item.val }}</span>
            </div>
          </li>
        </ul>
        <el-form style="margin-top: 20px;" v-else :model="edit_info" ref="ruleForm" label-width="160px"
          class="demo-ruleForm" size="small">
          <el-form-item :label="$t('message.table.name')" prop="name" :rules="nameRule">
            <el-input v-model="edit_info.name" :style="input_width"></el-input>
          </el-form-item>

          <el-form-item :label="$t('message.table.des')">
            <el-input v-model="edit_info.description" :style="input_width"></el-input>
          </el-form-item>

          <el-form-item :label="$t('message.table.status')">
            <el-select v-model="edit_info.actived" :placeholder="$t('message.placeholder.select')" size="small"
              :style="input_width" :disabled="!activedBtn">
              <el-option :label="this.$t('message.table.enabled_01')" value="1"></el-option>
              <el-option :label="this.$t('message.table.disabled_01')" value="0"></el-option>
            </el-select>
          </el-form-item>


          <!-- Gary添加class的order-->

          <el-form-item :label="$t('message.table.order')" v-if="classordershow">
            <el-input v-model="edit_info.reorder" :style="input_width" placeholder=""
              oninput="value=value.replace(/[^0-9.]/g,'')">
            </el-input>
          </el-form-item>

          <!-- <el-input v-model.number="ruleForm.sort" placeholder="请输入数字(限数字)" oninput="value=value.replace(/[^0-9.]/g,'')" /> -->

          <el-form-item :label="$t('message.title.autoNumber2')" v-if="autoNumberShow">
            <el-select v-model="edit_info.autoNumber" :placeholder="$t('message.placeholder.select')" size="small"
              :style="input_width">
              <el-option :label="this.$t('message.table.none')" value="-1"></el-option>
              <el-option v-for="item in autoNumber_lists" :label="item.name" :value="item.id"
                :key="item.index"></el-option>
            </el-select>
          </el-form-item>

          <!-- Gary添加subclass的order-->
          <el-form-item :label="$t('message.table.order')" v-if="subclassordershow">
            <el-input v-model="edit_info.reorder" :style="input_width" placeholder=""
              oninput="value=value.replace(/[^0-9.]/g,'')">
            </el-input>
          </el-form-item>


        </el-form>
      </div>

      <div class="tabs-info" v-show="tabs_info">
        <ul>
          <li v-for="(item, index) in tabs_data"
            :class="{ active2: index == num2, 'visible': item.visible == 0, 'liHover': item.id !== 1010103 }"
            :key="index">
            <!-- <el-tree
              ref="tree123"
              :expand-on-click-node="false"
              v-if="item.id == 1010103"
              :data="dataDemo"
              :props="defaultProps"
              @node-click="(data,node,item) => handleNodeClick(data,node,item,index)"
              >
            </el-tree> -->
            <el-collapse accordion v-if="item.id == 1010103">
              <div @click="tabsClick(item, index)" style="width: 100%;padding: 10px;margin: 0;">{{ item.name }}</div>

              <el-collapse-item>
                <template slot="title">

                </template>
                <div v-for="(item2, index2) in dataBoms" class="bomLists" :class="{ 'active2': index2 == bomListsNum }"
                  @click="tabsClick(item2, -1, index2)" :key="index2">
                  <!-- {{item2.name}} -->
                  <span style="margin-left: 15px;">{{ item2.name }}</span>
                </div>
              </el-collapse-item>
            </el-collapse>
            <p @click="tabsClick(item, index)" v-else>{{ item.name }}</p>
          </li>
        </ul>
      </div>




      <div class="lifecycle" v-if="lifecycle_info" style="margin-top: 10px;">
        <!-- <div @mouseover="add_img = add_img2" @mouseout="add_img = add_img1" class="btn btn1"
					@click="addDataEvent">
					<i>
						<img style="width: 100%;height: 100%;" :src="add_img" alt="">
					</i>
					<span>{{$t('message.button.add')}}</span>
				</div> -->
        <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="addDataEvent">{{ $t('message.button.add')
        }}</el-button>

        <div style="float: right;margin-right: 20px;">
          <el-button class="btn btn7" icon="el-icon-document-checked" @click="getUpdateEvent">{{
            $t('message.button.save')
          }}</el-button>
          <el-button class="btn btn8" icon="el-icon-circle-close" @click="closeSave">{{ $t('message.button.cancel')
          }}</el-button>

        </div>
        <div style="padding: 20px;padding-top: 10px;">
          <vxe-grid ref='xGridLifecycle' v-bind="gridLifecycle" @cell-dblclick="noEdit"></vxe-grid>
        </div>
      </div>
    </div>

    <div class="line-1" v-show="center_page"></div>
    <div class="right" v-show="right_page" style="background:#fff">
      <div>
        <ul class="right-title">
          <li @click="tab2Click(item, index)" :class="{ active2: index == num3 }" v-for="(item, index) in right_lists"
            :key="index">
            {{ item.name }}
          </li>
        </ul>
        <div style="height: 2px;background: #ebebeb;"></div>
      </div>

      <div v-if="num3 === 4">
        <table-collect />
      </div>

      <div v-else>
        <div class="right-info" v-if="titleblock">
          <div style="height: 30px;">
            <el-button type="primary" size="mini" style="float: right;margin-right: 10px;margin-top: 10px;"
              @click="editInfoRight" v-if="edit_subCls_info">{{ $t('message.button.edit') }}</el-button>
            <el-button size="mini" style="float: right;margin-right: 10px;margin-top: 10px;" @click="closeInfoRight"
              v-if="!edit_subCls_info">{{ $t('message.button.cancel') }}</el-button>
            <el-button type="success" size="mini" style="float: right;margin-right: 10px;margin-top: 10px;"
              @click="submitFormRight" v-if="!edit_subCls_info">{{ $t('message.button.save') }}</el-button>
          </div>
          <ul v-if="show_right_subCls_info"
            style="position: relative;overflow: hidden;list-style: none;width: 100%;padding: 0;">
            <li v-for="item in right_info_data" style="width: 100%;" :key="item.index">
              <div class="table-list">
                <span class="list-key-1">{{ item.name }}</span>
                <span style="display: inline-block;margin: 0 6px;">:</span>
                <span class="list-val" :title="item.val.val">{{ item.val }}</span>
              </div>
            </li>
          </ul>

          <el-form style="margin-top: 20px;" v-else :model="right_edit_info" ref="ruleForm2" label-width="100px"
            size="small">
            <el-form-item :label="$t('message.table.name')" prop="name" :rules="nameRule">
              <el-input v-model="right_edit_info.name" :style="input_width"></el-input>
            </el-form-item>

            <el-form-item :label="$t('message.table.des')">
              <el-input v-model="right_edit_info.description" :style="input_width"></el-input>
            </el-form-item>

            <el-form-item :label="this.$t('message.table.visible')">
              <el-select v-model="right_edit_info.visible" :placeholder="$t('message.placeholder.select')" size="small"
                :style="input_width">
                <el-option :label="this.$t('message.table.yes')" value="1"></el-option>
                <el-option :label="this.$t('message.table.no')" value="0"></el-option>
              </el-select>
            </el-form-item>


          </el-form>
        </div>

        <div v-if="page1">
          <div style="padding: 20px;">
            <vxe-grid ref='xGrid' v-bind="gridOptions" @cell-dblclick="dbClick"></vxe-grid>
          </div>
        </div>
      </div>

      <el-dialog v-if="pageListDataShow" class="edit-right-data" :title="editPageTitle" :visible.sync="pageListDataShow"
        @closed="dialogClose">
        <div style="height: 30px;">
          <el-button size="mini" style="float: right;margin-right: 10px;margin-top: 10px;"
            @click="closePageInfoRight">{{
              $t('message.button.cancel') }}</el-button>
          <el-button type="success" size="mini" style="float: right;margin-right: 10px;margin-top: 10px;"
            @click="submitPageFormRight">{{ $t('message.button.save') }}</el-button>
        </div>

        <el-form style="margin-top: 20px;" label-width="100px" size="small">
          <el-form-item :label="$t('message.table.name')" required>
            <el-input v-model="right_edit_info_data[1]" :style="input_width"
              :disabled="right_lists_disable[1] || right_list_disable"></el-input>
          </el-form-item>

          <el-form-item :label="$t('message.table.des')">
            <el-input v-model="right_edit_info_data[2]" :style="input_width"
              :disabled="right_lists_disable[2] || right_list_disable"></el-input>
          </el-form-item>

          <el-form-item :label="$t('message.table.visible')">
            <el-select v-model="right_edit_info_data[4]" :disabled="notSelect || right_lists_disable[4]"
              :placeholder="$t('message.placeholder.select')" size="small" :style="input_width">
              <el-option :label="$t('message.table.yes')" value="1" ref="isShow"></el-option>
              <el-option :label="$t('message.table.no')" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('message.table.required')" v-if="required">
            <el-select v-model="right_edit_info_data[5]" :placeholder="$t('message.placeholder.select')" size="small"
              :style="input_width" :disabled="right_lists_disable[5] || right_list_disable" @change="reqLinkShow">
              <el-option :label="$t('message.table.yes')" value="1"></el-option>
              <el-option :label="$t('message.table.no')" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('message.table.property')">
            <el-input v-model="right_edit_info_data[6]" :style="input_width"
              :disabled="right_lists_disable[6]"></el-input>
          </el-form-item>

          <el-form-item :label="$t('message.table.type')">
            <el-select v-model="right_edit_info_data[8]" :placeholder="$t('message.placeholder.select')" size="small"
              :style="input_width" :disabled="right_lists_disable[8]">
              <el-option :label="$t('message.table.text')" value="1"></el-option>
              <el-option :label="$t('message.table.textarea')" value="2"></el-option>
              <el-option :label="$t('message.table.selectList')" value="3"></el-option>
              <el-option :label="$t('message.table.multilist')" value="4"></el-option>
              <el-option :label="$t('message.table.date')" value="6"></el-option>
              <el-option :label="$t('message.table.number')" value="7"></el-option>
              <el-option label="Heading" value="8"></el-option>
              <el-option :label="$t('message.table.richText')" value="9"></el-option>
              <el-option :label="$t('message.table.money')" value="10"></el-option>
              <el-option :label="$t('message.table.placeholder')" value="11"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('message.table.list')" v-if="isSelectList">
            <el-select filterable clearable v-model="right_edit_info_data[7]"
              :placeholder="$t('message.placeholder.select')" size="small" :style="input_width"
              :disabled="right_lists_disable[7] || right_list_disable" @change="getSelect">
              <el-option v-for="item in right_select_lists" :label="item.name" :value="item.id"
                :key="item.index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('message.table.order')">
            <el-input type="number" v-model="right_edit_info_data[11]"
              oninput="value=parseInt(value.replace(/[^\d]/g,''))" :style="input_width"
              :disabled="right_lists_disable[11] || right_list_disable"></el-input>
          </el-form-item>

          <el-form-item :label="$t('message.table.defaultValue')" v-if="noDefaultValue">
            <!-- <el-form-item label= "$t('message.table.defaultValue')">  -->
            <el-input v-if="rightEditInfoDataInput" v-model="right_edit_info_data[12]" :style="input_width"
              :disabled="right_lists_disable[12] || right_list_disable"></el-input>
            <el-cascader v-if="cascade" :disabled="right_lists_disable[12] || right_list_disable" clearable
              :style="input_width" v-model="right_edit_info_data[12]" :options="defaultValList" :show-all-levels="false"
              :props="{ checkStrictly: true }">
            </el-cascader>
            <el-cascader clearable v-if="cascadeMultiple" :disabled="right_lists_disable[12] || right_list_disable"
              :style="input_width" v-model="right_edit_info_data[12]" :options="defaultValList" :show-all-levels="false"
              :props="{ checkStrictly: true, multiple: true }">
            </el-cascader>
            <el-select v-if="rightEditInfoDataSelect" :disabled="right_lists_disable[12] || right_list_disable"
              v-model="right_edit_info_data[12]" clearable :placeholder="$t('message.placeholder.select')"
              :style="input_width">
              <el-option v-for="items in defaultValList" :label="items.name" :value="items.id" :key="items.id">
              </el-option>
            </el-select>
            <el-select v-if="rightEditInfoDataMultiple" :disabled="right_lists_disable[12] || right_list_disable"
              v-model="right_edit_info_data[12]" clearable multiple :placeholder="$t('message.placeholder.select')"
              :style="input_width">
              <el-option v-for="items in defaultValList" :label="items.name" :value="items.id" :key="items.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>

    <el-dialog class="edit-right-data" :title="addSubClsPageTitle" :visible.sync="addSubClsPage"
      @closed="addDialogClose">
      <el-form style="margin-top: 20px;" :model="add_subCls_info" ref="ruleForm2" label-width="100px" size="small">
        <el-form-item :label="$t('message.table.name')" required>
          <el-input v-model="add_subCls_info.name" :style="input_width"></el-input>
        </el-form-item>

        <el-form-item :label="$t('message.table.des')">
          <el-input v-model="add_subCls_info.description" :style="input_width"></el-input>
        </el-form-item>

        <el-form-item :label="$t('message.table.status')">
          <el-select clearable v-model="add_subCls_info.actived" :placeholder="$t('message.placeholder.select')"
            size="small" :style="input_width" @change="selChange">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>



      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addSubClsPage = false">{{ $t('message.button.cancel') }}</el-button>
        <el-button type="success" @click="saveSubCls" :disabled='!saveAllow'>{{ $t('message.button.createNow')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import axios from "axios";
import { publicList } from "@/utils/publicstate";
import tableCollect from './classConfig/rightBoard/index.vue';
export default {
  components: { tableCollect },
  name: 'classes',
  data() {
    return {



      bomListsNum: 0,
      dataBoms: [],

      centerTabId: "",//用户界面标签点击id
      rightEditInfoDataInput: false,
      rightEditInfoDataSelect: false,
      rightEditInfoDataMultiple: false,
      cascade: false,
      cascadeMultiple: false,
      noDefaultValue: false,

      nameRule: [
        { required: true, message: this.$t('message.warning.name') }
      ],
      activedBtn: false,
      notSelect: false,
      lifecycle_info: false,//生命周期阶段

      listClsId: '',
      autoNumberShow: false,
      classordershow: false,
      subclassordershow: false,
      appendNode: [],
      required: Boolean,
      defaultValList: [],

      old_grid_data: [],
      typeOptions: [{
        label: this.$t('message.table.enabled_01'),
        value: 1,
      }, {
        label: this.$t('message.table.disabled_01'),
        value: 0,
      },
      ],

      gridLifecycle: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: 'id',
        height: "650",
        size: "small",
        columns: [{
          field: 'phaseName',
          title: this.$t('message.table.name'),
          editRender: {
            name: '$input',
            props: {
              placeholder: this.$t('message.placeholder.input'),
            }
          },
        }, {
          field: 'description',
          title: this.$t('message.table.des'),
          editRender: {
            name: '$input'
          },
        }, {
          field: 'enabled',
          title: this.$t('message.table.enabled_01'),
          editRender: {
            name: '$select',
            options: [{
              label: this.$t('message.table.yes'),
              value: 1,
            }, {
              label: this.$t('message.table.no'),
              value: 0,
            },

            ]
          },
        }],
        data: [],
        editConfig: {
          trigger: 'dblclick',
          mode: 'row',
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        editRules: {
          phaseName: [{
            required: true,
            message: this.$t('message.warning.name'),
          },
          {
            min: 1,
            max: 18,
            message: this.$t('message.warning.length_105')
          }
          ]
        },
        sortConfig: {
          trigger: 'cell'
        },
      },

      add_subCls_info: {
        name: "",
        description: "",
        actived: Number
      },
      add_subCls_Ids: {},
      addSubClsPageTitle: "1",
      addSubClsPage: false,
      addClsId: "",

      right_list_disable: false,//table根据subcls不编辑其他都可以编辑
      clickData: '',
      clickNode: "",
      isCls: {
        name: "",
        val: ""
      },

      parentData: {},
      showTree: true, //树高亮显示

      num2: -1, //中间标签页
      tabs_info: false,

      center_page: false,
      tabs_data: [],
      base_info: false, //基础信息
      edit_base_info: true, //编辑基础信息
      show_base_info: true,
      edit_info: {},
      base_view_data: [{
        name: this.$t('message.table.name'),
        id: "name",
        val: "",
        disabled: true
      }, {
        name: this.$t('message.table.des'),
        id: "description",
        val: "",
        disabled: true
      }, {
        name: this.$t('message.table.status'),
        id: "actived",
        val: "",
        disabled: true
        // Gary添加class的order和subclass的order代码
      }, {
        name: this.$t('message.title.autoNumber2'),
        id: "autoNumber",
        val: "",
        disabled: false
      },
      {
        name: this.$t('message.table.order'),
        id: "classorder",
        val: "",
        disabled: false
      },

      {
        name: this.$t('message.table.order'),
        id: "subclassorder",
        val: "",
        disabled: false
      }],

      num: "0",
      center_tabinfo: {},
      input_width: {},
      tab_all_id: [{ //公用tabid
        name: this.$t('message.table.baseInfo'),
      }],
      props: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      },

      // 右边页面
      num3: 0,
      right_lists: [{ //公用tabid
        name: this.$t('message.table.baseInfo'),
      }],
      right_info_data: [{
        name: this.$t('message.table.name'),
        id: "name",
        val: ""
      }, {
        name: this.$t('message.table.des'),
        id: "description",
        val: ""
      }, {
        name: this.$t('message.table.visible'),
        id: "actived",
        val: ""
      }],
      edit_subCls_info: true,
      show_right_subCls_info: true,
      right_page: false,
      right_edit_info: {},
      right_edit_info_old: {},
      right_tabinfo: {},
      titleblock: true,
      right_lists_disable: {},

      // pg1
      right_tab_info: {},
      page1: false,
      gridOptions: {
        resizable: true,//列是否允许拖动列宽调整大小
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: 'id',
        height: "730",
        size: "small",
        columns: [{
          field: 'orders',
          title: this.$t('message.table.order'),
        }, {
          field: 'names',
          title: this.$t('message.table.name'),
          sortable: true,
        }, {
          field: 'uiType',
          title: this.$t('message.table.type'),
          filters: [
            { label: this.$t('message.table.text'), value: this.$t('message.table.text') },
            { label: this.$t('message.table.textarea'), value: this.$t('message.table.textarea') },
            { label: this.$t('message.table.selectList'), value: this.$t('message.table.selectList') },
            { label: this.$t('message.table.multilist'), value: this.$t('message.table.multilist') },
            { label: this.$t('message.table.date'), value: this.$t('message.table.date') },
            { label: this.$t('message.table.number'), value: this.$t('message.table.number') },
            { label: 'Heading', value: 'Heading' },
            { label: this.$t('message.table.money'), value: this.$t('message.table.money') },
            { label: this.$t('message.table.placeholder'), value: this.$t('message.table.placeholder') }
          ],
          filterMultiple: false,
        }, {
          field: 'visible',
          title: this.$t('message.table.visible'),
          filters: [
            { label: this.$t('message.table.yes'), value: this.$t('message.table.yes') },
            { label: this.$t('message.table.no'), value: this.$t('message.table.no') }
          ],
          filterMultiple: false,
        }, {
          field: 'required',
          title: this.$t('message.table.required'),
          filters: [
            { label: this.$t('message.table.yes'), value: this.$t('message.table.yes') },
            { label: this.$t('message.table.no'), value: this.$t('message.table.no') }
          ],
          filterMultiple: false,
        }],
        data: [],
        sortConfig: {
          trigger: 'cell'
        },
      },
      pageListDataShow: false,
      editPageTitle: "",
      right_edit_info_data: [],
      show_right_edit_info: true,
      right_edit_info_data_old: {},//编辑旧数据
      attributeInfo: {},
      right_select_lists: {},
      isSelectList: false,
      autoNumber_lists: [],//autoNumber列表
      Global: publicList().Global,

    }
  },
  computed: {
    saveAllow() {
      return !!this.add_subCls_info.name
    },
  },
  activated() {
    this.getSelectLists();
  },
  created() {
    this.getSelectLists();
    //this.$store.commit('setIncludesList', 'classes');

  },
  methods: {
    bomsTitleClick(res) {
      console.log(res);
    },
    handleNodeClick(data, node, item, index) {
      console.log(data);
      console.log(index);
      this.num2 = -1;
      this.tabsClick(data, index);
    },

    reqLinkShow(e) {
      if (e == 1) {
        // console.log(this.$refs.isShow);
        this.right_edit_info_data[4] = this.$refs.isShow.value;
        this.notSelect = true;
      } else {
        this.notSelect = false;
      }
    },
    append(data, node) {
      this.appendNode = node;
      this.addSubClsPage = true;
      this.addSubClsPageTitle = data.name + ": " + this.$t('message.table.newSub');
      this.addClsId = data.classesId;
      this.add_subCls_info = {};
      //console.log(data);
      this.add_subCls_Ids.cls = data.classesId;
      this.add_subCls_Ids.baseCls = data.parentId;
      this.add_subCls_info.actived = 1;

    },
    delSubCls(data, node) {
      console.log(node);
      console.log(data);
      let vm = this;
      this.$confirm(this.MessageInfo.m_302, data.name, {
        confirmButtonText: this.$t('message.button.affirm'),
        cancelButtonText: this.$t('message.button.cancel'),
        type: 'warning'
      }).then(() => {
        var obj_get = {
          baseClassId: data.baseClsId,
          subClassId: data.subClsesId
        };
        var loadTableUrl = `/pmdm/admin/cls/deleteSubclassById${this.params(obj_get)}`;
        axios.get(loadTableUrl)
          .then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              vm.refreshLazyTree();
              vm.center_page = false;
              vm.$message({
                type: 'success',
                message: res.data.message
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('message.tips.deleteCancel')
        });
      });
    },
    selChange() {
      // if (val) {
      //   // 操作选中角色发生变化
      //   console.log(1111);
      //   this.$set(this.add_subCls_info, this.add_subCls_info.actived, val)
      // }
      this.$forceUpdate();
    },
    selChange02() {
      if (val) {
        // 操作选中角色发生变化
        console.log(222);
        this.$set(this.add_subCls_info, this.add_subCls_info.actived, val)
      }
    },
    saveSubCls() {
      //console.log(this.add_subCls_info);
      var vm = this;
      console.log(this.add_subCls_info.name);
      this.add_subCls_info.name = this.add_subCls_info.name.trim();
      if (!this.add_subCls_info.name || this.add_subCls_info.name.match(/^[ ]*$/)) {
        this.$message.error(this.$t('message.error.name'))
        return false
      }
      if (JSON.stringify(this.add_subCls_info) !== "{}") {
        let obj = {
          baseClsId: this.add_subCls_Ids.baseCls,
          clsId: this.add_subCls_Ids.cls,
          description: this.add_subCls_info.description,
          name: this.add_subCls_info.name,
          actived: this.add_subCls_info.actived,
        };
        if (this.add_subCls_info.actived == this.$t('message.table.enabled_01')) {
          obj.actived = 0;
        }

        console.log(vm.appendNode);
        axios.post('/pmdm/admin/cls/saveSubCls', obj)
          .then((res) => {
            if (res.data.code == 200) {
              vm.refreshLazyTree(vm.appendNode);
              vm.$message({
                type: 'success',
                message: res.data.message + this.$t('message.tips.reLogin'),
              });
              vm.closeInfo();
              vm.listClick(vm.clickData, vm.clickNode);
            } else {
              vm.$message.error(this.$t('message.error.save'));
            }
          })
          .catch(function (error) {
            console.log(error);
          });
        this.addSubClsPage = false;

      } else {
        vm.$message.error(this.$t('message.error.input'));
      }

    },
    async getSelectLists() {
      const {//获取cls的lists
        data: clsList
      } = await this.$http.get("/pmdm/admin/cls/getLists");
      //console.log(res);
      var res = clsList.object.listEntities;
      var lists = [];
      for (var i = 0; i < res.length; i++) {
        var obj = {};
        obj.name = res[i].name;
        obj.id = res[i].id + "";
        lists.push(obj);
      };
      //console.log(lists);
      this.right_select_lists = lists;

      const {//获取autoNumber的lists
        data: autoNumberList
      } = await this.$http.get("/pmdm/admin/autonumber/getActivedAutoNumbers");
      // console.log(res2);
      this.autoNumber_lists = autoNumberList.object.autoNumbers;
      // this.center_page = false;
    },
    submitForm() {
      // console.log(this.isCls);
      console.log(this.edit_info);

      this.edit_info.name = this.edit_info.name.trim();
      if (!this.edit_info.name || this.edit_info.name.match(/^[ ]*$/)) {
        this.$message.error(this.$t('message.error.name'))
        return false
      }
      // if(!this.edit_info.name){
      //   this.$message.error(this.$t("message.warning.required"));
      //   return false;
      // }
      var vm = this;
      if (this.isCls.name == "baseClassesId") {
        var obj = {};
        var val = this.isCls.val;
        //console.log(val);
        for (var key in this.edit_info) {
          if (this.edit_info[key] !== this.old_edit_base_info[key]) {
            obj[key] = this.edit_info[key];
          };
        };
        if (JSON.stringify(obj) == "{}") {
          // this.$message.error(this.MessageInfo.e_203);
          return false;
        } else {
          obj.id = val;
        };
        axios.post('/pmdm/admin/cls/updateBaseCls', obj)
          .then((res) => {
            //console.log(res);
            if (res.data.code == 200) {
              vm.refreshLazyTree();
              vm.$message({
                type: 'success',
                message: res.data.message,
              });
              vm.closeInfo();
              vm.listClick(vm.clickData, vm.clickNode);
            } else {
              vm.$message.error(this.$t('message.error.save'));
            }
          })
          .catch(function (error) {
            console.log(error);
          });
        //console.log(obj)
        clearTimeout(this.timer);  //清除延迟执行

        this.timer = setTimeout(() => {   //设置延迟执行
          this.updateTree();
        }, 500);
      };

      if (this.isCls.name == "classesId") {
        var obj = {};
        var val = this.isCls.val;
        //console.log(val);
        for (var key in this.edit_info) {
          if (this.edit_info[key] !== this.old_edit_base_info[key]) {
            obj[key] = this.edit_info[key];
          };
        };
        if (JSON.stringify(obj) == "{}") {
          // this.$message.error(this.MessageInfo.e_203);
          return false;
        } else {
          obj.id = val;
        };
        axios.post('/pmdm/admin/cls/updateCls', obj)
          .then((res) => {
            if (res.data.code == 200) {
              vm.refreshLazyTree();
              vm.$message({
                type: 'success',
                message: res.data.message,
              });
              vm.closeInfo();
              vm.listClick(vm.clickData, vm.clickNode);
            } else {
              vm.$message.error(this.$t('message.error.save'));
            }
          })
          .catch(function (error) {
            console.log(error);
          });
        //console.log(obj)
      };


      if (this.isCls.name == "subClsesId") {
        var obj = {};
        var val = this.isCls.val;
        //console.log(val);
        for (var key in this.edit_info) {
          if (this.edit_info[key] !== this.old_edit_base_info[key]) {
            obj[key] = this.edit_info[key];
          };
        };
        if (JSON.stringify(obj) == "{}") {
          // this.$message.error(this.MessageInfo.e_203);
          return false;
        } else {
          obj.id = val;
        };
        axios.post('/pmdm/admin/cls/updateSubCls', obj)
          .then((res) => {
            if (res.data.code == 200) {
              vm.refreshLazyTree();
              vm.$message({
                type: 'success',
                message: res.data.message,
              });
              vm.closeInfo();
              vm.listClick(vm.clickData, vm.clickNode);
            } else {
              vm.$message.error(this.$t('message.error.save'));
            }
          })
          .catch(function (error) {
            console.log(error);
          });
        //console.log(obj)
      };

    },
    async updateTree() {
      console.log("updateTree")
      const { data: res } = await this.$http.get("/pmdm/menus/tree");
      console.log(res)
      this.$store.commit("setMenuList", res.object.tree);
    },
    closeInfo() {
      this.edit_base_info = true;
      this.show_base_info = true;
      this.edit_info = this.old_edit_base_info;
    },
    editInfo() {
      this.show_base_info = false;
      this.edit_base_info = false;
      this.old_edit_base_info = this.deepClone(this.edit_info);
    },
    loadNode(node, resolve) {
      //console.log(node);
      node.childNodes = [];
      if (node.level === 0) {
        this.input_width = this.Global.input_width;
        axios.get('/pmdm/admin/cls/getBaseClses')
          .then((res) => {
            var base_classes = res.data.object.baseClses;
            //console.log(base_classes);
            var base_data = [];
            for (var i = 0; i < base_classes.length; i++) {
              var obj = {};
              obj.name = base_classes[i].name;
              obj.baseClassesId = base_classes[i].id;
              obj.actived = base_classes[i].actived;
              base_data.push(obj);
            };
            return resolve(base_data);
          })
          .catch(function (error) {
            console.log(error);
          });
      };

      if (node.level === 1) {
        var baseClassesId_ = node.data.baseClassesId;
        this.right_list_disable = false;
        //console.log(node.data);
        axios.get('/pmdm/admin/cls/getClses?baseClsId=' + baseClassesId_)
          .then((res) => {
            var base_data = [];
            var classes_ = res.data.object.clses;
            for (var i = 0; i < classes_.length; i++) {
              var obj = {};
              obj.name = classes_[i].name;
              obj.classesId = classes_[i].id;
              obj.parent = node.data.name;
              obj.parentId = node.data.baseClassesId;
              obj.actived = classes_[i].actived;
              base_data.push(obj);
            };
            return resolve(base_data);
          })
          .catch(function (error) {
            // console.log(error);
          });
      };

      if (node.level === 2) {
        var classesId_ = node.data.classesId;
        this.right_list_disable = true;
        axios.get('/pmdm/admin/cls/getSubClses?clsId=' + classesId_)
          .then((res) => {
            var base_data = [];
            //console.log(res);
            var classes_ = res.data.object.subClses;
            for (var i = 0; i < classes_.length; i++) {
              var obj = {};
              obj.name = classes_[i].name;
              obj.subClsesId = classes_[i].id;
              obj.baseClsId = classes_[i].baseClsId;
              obj.leaf = true;
              obj.parent = node.data.name;
              obj.actived = classes_[i].actived;
              base_data.push(obj);
            };
            return resolve(base_data);
          })
          .catch(function (error) {
            // console.log(error);
          });
      };
    },

    listClick(data, node) {
      console.log(data);

      const { path } = this.$route;
      this.$router.replace({ path, query: data });

      this.closeInfo();
      this.base_view_data[3].disabled = false;
      this.base_view_data[4].disabled = false;
      this.base_view_data[5].disabled = false;
      this.autoNumberShow = false;
      this.classordershow = false;
      this.subclassordershow = false;

      this.clickData = data;
      this.clickNode = node;
      this.parentData = node.parent;
      var vm = this;
      this.num = 0;
      this.center_page = true;
      this.tabs_info = false;
      this.right_page = false;
      this.lifecycle_info = false;
      // console.log(data);
      if (data.baseClassesId) {
        console.log('base', data);
        this.isCls.name = 'baseClassesId';
        this.isCls.val = data.baseClassesId;

        vm.tab_all_id = [{
          name: this.$t('message.table.baseInfo'),
        }];
        axios.get('/pmdm/admin/cls/getBaseCls?id=' + data.baseClassesId)
          .then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              vm.base_info = true;
              let baseClass = res.data.object.baseCls;
              vm.edit_info = baseClass;
              vm.base_view_data[0].val = baseClass.name;
              vm.base_view_data[1].val = baseClass.description;
              if (baseClass.actived == 1) {
                vm.base_view_data[2].val = this.$t('message.table.enabled_01');
              } else {
                vm.base_view_data[2].val = this.$t('message.table.disabled_01');
              };
              if (baseClass.autoNumber == -1) {
                vm.base_view_data[3].val = this.$t('message.table.none');
              } else {
                vm.base_view_data[3].val = this.$t('message.table.disabled_01');
              };
              vm.edit_info.actived = baseClass.actived + "";
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
      };
      if (data.classesId) {
        //this.autoNumberShow= false;
        this.classordershow = true;
        //this.subclassordershow = false;
        this.base_view_data[4].disabled = true;
        console.log('class', data);
        this.isCls.name = 'classesId';
        this.isCls.val = data.classesId;
        this.right_list_disable = false;
        if (data.parentId == "101" || data.parentId == "105" || data.parentId == "106" || data.parentId == "501") {
          vm.tab_all_id = [{
            name: this.$t('message.table.baseInfo'),
          }, {
            name: this.$t('message.table.mark'),
          }, {
            name: this.$t('message.table.lifecyclephases'),
            classId: data.classesId,
          }];
        } else {
          vm.tab_all_id = [{
            name: this.$t('message.table.baseInfo'),
          }, {
            name: this.$t('message.table.mark'),
          }];
        };
        axios.get('/pmdm/admin/cls/getCls?id=' + data.classesId)
          .then((response) => {
            //console.log(res);
            if (response.data.code == 200) {
              vm.base_info = true;
              let res = response.data.object.cls;
              vm.edit_info = res;
              vm.base_view_data[0].val = res.name;
              vm.base_view_data[1].val = res.description;
              vm.base_view_data[4].val = res.reorder;
              if (res.actived == 1) {
                vm.base_view_data[2].val = this.$t('message.table.enabled_01');
              } else {
                vm.base_view_data[2].val = this.$t('message.table.disabled_01');
              };
              vm.edit_info.actived = res.actived + "";
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      };
      if (data.subClsesId) {
        this.autoNumberShow = true;
        //this.classordershow = false;
        this.subclassordershow = true;
        console.log('sub', data.subClsesId);
        this.isCls.name = 'subClsesId';
        this.isCls.val = data.subClsesId;
        this.right_list_disable = true;
        this.base_view_data[3].disabled = true;
        this.base_view_data[5].disabled = true;


        if (data.baseClsId == "101" || data.baseClsId == "105" || data.baseClsId == "106") {
          vm.tab_all_id = [{
            name: this.$t('message.table.baseInfo'),
          }, {
            name: this.$t('message.table.mark'),
          }, {
            name: this.$t('message.table.lifecyclephases'),
            subClassId: data.subClsesId,
          }];
        } else {
          vm.tab_all_id = [{
            name: this.$t('message.table.baseInfo'),
          }, {
            name: this.$t('message.table.mark'),
          }];
        };
        axios.get('/pmdm/admin/cls/getSubCls?id=' + data.subClsesId)
          .then((response) => {
            //console.log(res);
            if (response.data.code == 200) {
              vm.base_info = true;
              let res = response.data.object.subCls;
              vm.edit_info = res;
              vm.base_view_data[0].val = res.name;
              vm.base_view_data[1].val = res.description;
              vm.base_view_data[5].val = res.reorder;

              if (res.actived == 1) {
                vm.base_view_data[2].val = this.$t('message.table.enabled_01');
              } else {
                vm.base_view_data[2].val = this.$t('message.table.disabled_01');
              };
              if (res.autoNumber == -1) {
                vm.base_view_data[3].val = this.$t('message.table.none');
                vm.edit_info.autoNumber = res.autoNumber + "";
              } else {
                for (var i = 0; i < vm.autoNumber_lists.length; i++) {
                  // console.log(res.autoNumber);
                  // console.log(vm.autoNumber_lists[i]);
                  if (vm.autoNumber_lists[i].id == res.autoNumber) {
                    vm.base_view_data[3].val = vm.autoNumber_lists[i].name;
                  }
                }
              };
              vm.edit_info.actived = res.actived + "";
              let notAuto = [10501, 10601, 90101, 90201]
              if (notAuto.includes(res.clsId)) {
                vm.autoNumberShow = false;
                vm.base_view_data[3].disabled = false;
                //vm.base_view_data.pop()
              } else {
                this.base_view_data[3].disabled = true;
                vm.autoNumberShow = true;
              }
              console.log(vm.base_view_data);
              console.log('atNum', vm.autoNumberShow);
            };
          })
          .catch(function (error) {
            console.log(error);
          });
      };
      // console.log(data,this.$refs.ftree);
      if (data.baseClassesId) {
        this.base_view_data[3].disabled = false;
        this.activedBtn = false;
      } else {
        this.activedBtn = true;
      }

    },

    tabClick(res, index) {
      this.num = index;
      this.center_tabinfo = res;
      var name_ = res.name;
      //console.log(res);
      var vm = this;
      if (name_ == this.$t('message.table.baseInfo')) {
        //admin/cls/getTabsByClsId
        vm.tabs_info = false;
        vm.base_info = true;
        vm.right_page = false;
        vm.lifecycle_info = false;
      };
      if (name_ == this.$t('message.table.mark')) {
        vm.right_page = false;
        vm.tabs_info = true;
        vm.base_info = false;
        vm.lifecycle_info = false;
        //console.log(this.isCls);
        if (this.isCls.name == "classesId") {
          axios.get('/pmdm/admin/cls/getTabsByClsId?clsId=' + this.isCls.val)
            .then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                vm.tabs_data = res.data.object.tabs;
                vm.dataBoms = res.data.object.boms;
                // console.log(vm.$refs.tree);
                // vm.$refs.tree.setCheckedNodes(treeChildrenData);
                //console.log(vm.dataDemo.children);
              };

            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          axios.get('/pmdm/admin/cls/getTabsBySubClsId?subClsId=' + this.isCls.val)
            .then((res) => {
              //console.log(res);
              if (res.data.code == 200) {
                vm.tabs_data = res.data.object.tabs;
              };

            })
            .catch(function (error) {
              console.log(error);
            });
        }
      };
      if (name_ == this.$t('message.table.lifecyclephases')) {
        vm.right_page = false;
        vm.tabs_info = false;
        vm.base_info = false;
        vm.lifecycle_info = true;
        //console.log(this.isCls);
        var vm = this;
        var getLCP = 'getLifecyclePhaseByClass?clsId=';
        if (res.subClassId) {
          getLCP = 'getLifecyclePhaseBySubclass?subclassId=';
        }
        axios.get('/pmdm/admin/lifecycle/' + getLCP + this.isCls.val)
          .then((res) => {
            var lifecycleData = res.data.object.phases;

            vm.gridLifecycle.data = vm.deepClone(lifecycleData);
            vm.old_grid_data = vm.deepClone(lifecycleData);
          })
          .catch(function (error) {
            console.log(error);
          });
      };
    },

    tabsClick(res, index, bomsIndex) {
      this.bomListsNum = index == -1 ? bomsIndex : -1;//多bom列表点击显示蓝色背景
      this.required = false;
      this.num2 = index;

      console.log(res);
      const arr = [1010101, 1010401, 1010501, 1010601, 1090101, 1090201, 1030101, 4040101, 1050101, 1050201]
      if (arr.indexOf(res.id) != -1 || res.name === 'BOM') {
        this.required = true
      };
      this.centerTabId = res.id;
      this.right_tabinfo = res;
      var vm = this;
      this.titleblock = true;
      this.page1 = false;
      this.right_lists = this.Global.right_lists_0;
      if (this.isCls.name == "subClsesId") {
        for (var i = 0; i < arr.length; i++) {
          if (res.id == arr[i]) {
            //sdfas
            this.right_lists = this.Global.right_lists_1_2;
          };
        }
        if (res.classId === 104) {
          // this.right_lists.push({ name: '表格自定义', id: 1289 })
          this.right_lists = [...this.right_lists, { name: '表格自定义', id: 1289 }]
        }
      } else if (res.id > 1010108 && res.id < 1010119) {
        let GlobalRightInfo = [
          { name: this.$t("message.list.baseInfo") },
          {
            name: res.name,
            id: -1
          }
        ];
        switch (res.id) {
          case 1010109:
            GlobalRightInfo[1].id = 4000;
            break;
          case 1010110:
            GlobalRightInfo[1].id = 4001;
            break;
          case 1010111:
            GlobalRightInfo[1].id = 4002;
            break;
          case 1010112:
            GlobalRightInfo[1].id = 4003;
            break;
          case 1010113:
            GlobalRightInfo[1].id = 4004;
            break;
          case 1010114:
            GlobalRightInfo[1].id = 4005;
            break;
          case 1010115:
            GlobalRightInfo[1].id = 4006;
            break;
          case 1010116:
            GlobalRightInfo[1].id = 4007;
            break;
          case 1010117:
            GlobalRightInfo[1].id = 4008;
            break;
          case 1010118:
            GlobalRightInfo[1].id = 4009;
            break;
        };
        this.right_lists = GlobalRightInfo;
      } else {
        switch (res.id) {
          case 1010101:
          case 1010401:
          case 1010501:
          case 1010601:
          case 1090101:
          case 1090201:
          case 4040101:
          case 1050101:
          case 1050201:
            console.log("2");
            this.right_lists = this.Global.right_lists_1;
            break;
          //变更
          case 1010102:
            this.right_lists = this.Global.right_lists_2;
            break;
          //bom
          case 1010103:
            this.right_lists = this.Global.right_lists_3;
            break;
          //制造商
          case 1010104:
            this.right_lists = this.Global.right_lists_4;
            break;
          //附件
          // case 1010105:
          case 1010602:
          case 1010404:
          case 1090101:
          case 1090205:
          case 1090108:
          case 1010502:
          case 1030105:
          case 4040109:
          case 1050107:
          case 1050204:
            this.right_lists = this.Global.right_lists_5;
            break;
          case 1010105:
            this.right_lists = this.Global.right_lists_40;
            break;
          //使用位置
          case 1010106:
            this.right_lists = this.Global.right_lists_6;
            break;
          //计划
          case 1030102:
            this.right_lists = this.Global.right_lists_23;
            break;
          //执行者
          case 1030103:
            this.right_lists = this.Global.right_lists_22;
            break;
          //质量-问题对象
          case 4040103:
            this.right_lists = this.Global.right_lists_26;
            break;
          //质量-关联相同表单
          case 4040107:
            this.right_lists = this.Global.right_lists_27;
            break;
          // 物料页签的质量单
          case 1010108:
            this.right_lists = this.Global.right_lists_28;
            break;
          // 产品数据-工艺信息
          case 1010119:
            this.right_lists = this.Global.right_lists_39;
            break;
          //关联对象
          case 1010107:
          case 1010604:
          case 1010405:
          case 1090204:
          case 1010504:
          case 4040111:
            this.right_lists = this.Global.right_lists_7;
            break;
          //执行者
          case 1030103:
            this.right_lists = this.Global.right_lists_22;
            break;
          //计划备注
          case 1030104:
            this.right_lists = this.Global.right_lists_24;
            break;
          //交付件
          case 1030106:
            this.right_lists = this.Global.right_lists_21;
            break;
          //历史记录
          // case 1010108:
          //   this.right_lists = this.Global.right_lists_8;
          // break;
          case 1010130:
            this.right_lists = this.Global.right_lists_8;
            break;
          case 1010406:
            this.right_lists = this.Global.right_lists_14;
            break;
          case 1010505:
            this.right_lists = this.Global.right_lists_15;
            break;
          case 1010605:
            this.right_lists = this.Global.right_lists_16;
            break;
          case 1090109:
            this.right_lists = this.Global.right_lists_17;
            break;
          case 1090206:
            this.right_lists = this.Global.right_lists_18;
            break;
          case 1030109:
            this.right_lists = this.Global.right_lists_20;
            break;
          case 4040113:
            this.right_lists = this.Global.right_lists_25;
            break;
          case 1050118:
            this.right_lists = this.Global.right_lists_34;
            break;
          case 1050215:
            this.right_lists = this.Global.right_lists_38;
            break;
          //变更对象
          case 1010402:
            this.right_lists = this.Global.right_lists_9;
            break;
          //用户首选项
          case 1090102:
            this.right_lists = this.Global.right_lists_10;
            break;
          //用户用户组
          case 1090107:
            this.right_lists = this.Global.right_lists_11;
            break;
          //用户组用户
          case 1090202:
            this.right_lists = this.Global.right_lists_12;
            break;
          //制造商/部件使用位置
          case 1010503:
            this.right_lists = this.Global.right_lists_13;
            break;
          case 1010603:
            this.right_lists = this.Global.right_lists_19;
            break;
          //工艺管理
          //工艺管理-变更审批
          case 1050102:
            this.right_lists = this.Global.right_lists_29;
            break;
          //工艺管理-工艺管理BOM
          case 1050103:
            this.right_lists = this.Global.right_lists_30;
            break;
          //工艺管理-关联物料
          case 1050104:
            this.right_lists = this.Global.right_lists_31;
            break;
          //工艺管理-关联资源/资源组
          case 1050105:
            this.right_lists = this.Global.right_lists_32;
            break;
          //工艺管理-所属工艺路线
          case 1050106:
            this.right_lists = this.Global.right_lists_33;
            break;
          //资源库
          //资源库-所属工艺
          case 1050203:
            this.right_lists = this.Global.right_lists_35;
            break;
          //资源库-所属资源
          case 1050202:
            this.right_lists = this.Global.right_lists_37;
            break;
          //资源库-所属资源组
          // case :
          //   this.right_lists = this.Global.right_lists_36;
          // break;

          case 1030101:
            vm.right_lists = this.Global.right_lists_1;
            break;
          default:
            this.right_lists = this.Global.right_lists_0;
            break;
        };
      };

      if (this.isCls.name == "classesId") {
        axios.get('/pmdm/admin/cls/getTabByClsId?clsId=' + this.isCls.val + "&id=" + res.id)
          .then(res => {
            // console.log(res);
            if (res.data.code == 200) {
              vm.right_page = true;
              vm.num3 = 0;
              vm.right_edit_info = res.data.object.tab;
              vm.right_edit_info_old = vm.deepClone(res.data.object.tab);
              vm.right_edit_info.visible = res.data.object.tab.visible + "";
              vm.right_edit_info_old.visible = res.data.object.tab.visible + "";

              vm.right_info_data[0].val = vm.right_edit_info.name;
              vm.right_info_data[1].val = vm.right_edit_info.description;
              if (vm.right_edit_info.visible == 1) {
                vm.right_info_data[2].val = this.$t('message.table.yes');
              } else {
                vm.right_info_data[2].val = this.$t('message.table.no');
              };
            };
          })
          .catch(function (error) {
            console.log(error);
          });
      } else if (this.isCls.name == "subClsesId") {
        axios.get('/pmdm/admin/cls/getTabBySubClsId?subClsId=' + this.isCls.val + "&id=" + res.id)
          .then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              vm.right_page = true;
              vm.num3 = 0;
              vm.right_edit_info = res.data.object.tab;
              vm.right_edit_info_old = vm.deepClone(res.data.object.tab);
              vm.right_edit_info.visible = res.data.object.tab.visible + "";
              vm.right_edit_info_old.visible = res.data.object.tab.visible + "";

              vm.right_info_data[0].val = vm.right_edit_info.name;
              vm.right_info_data[1].val = vm.right_edit_info.description;
              if (vm.right_edit_info.visible == 1) {
                vm.right_info_data[2].val = this.$t('message.table.yes');
              } else {
                vm.right_info_data[2].val = this.$t('message.table.no');
              };
            };
          })
          .catch(function (error) {
            console.log(error);
          });
      };
      console.log(this.right_lists);
    },

    editInfoRight() {
      this.show_right_subCls_info = false;
      this.edit_subCls_info = false;
    },
    closeInfoRight() {
      //console.log(this.right_edit_info_old);
      this.right_edit_info = this.deepClone(this.right_edit_info_old);

      this.show_right_subCls_info = true;
      this.edit_subCls_info = true;
    },
    submitFormRight() {
      let obj = {};
      var vm = this;
      this.right_edit_info.name = this.right_edit_info.name.trim();
      if (!this.right_edit_info.name || this.right_edit_info.name.match(/^[ ]*$/)) {
        this.$message.error(this.$t('message.error.name'))
        return false
      }

      obj.classId = this.isCls.val;
      obj.id = this.right_tabinfo.id;
      obj.name = this.right_edit_info.name;
      obj.visible = this.right_edit_info.visible;
      obj.description = this.right_edit_info.description;
      axios.post('/pmdm/admin/cls/updateTab', obj)
        .then((res) => {
          //console.log(res);
          if (res.data.code == 200) {
            vm.closeInfoRight();
            vm.tabClick(vm.center_tabinfo, vm.num);
            vm.tabsClick(vm.right_tabinfo, vm.num2);
            vm.$message({
              type: 'success',
              message: res.data.message,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      //console.log(obj);
    },

    tab2Click(res, index) {


      // console.log(this.center_page);
      // console.log(this.right_lists);
      // console.log(this.right_edit_info.visible);
      this.num3 = index;
      this.right_tab_info = res;
      var name_ = res.name;
      console.log(res);
      console.log(this.num3);

      if (res.id === 1289) {
        return
      }

      var vm = this;
      if (name_ == this.$t('message.table.baseInfo')) {
        vm.titleblock = true;
        vm.page1 = false;
      } else {
        vm.titleblock = false;
        vm.page1 = true;
        vm.table_id = res.id;

        let tabId;
        switch (this.isCls.val) {
          case 10501:
            tabId = 13
            break;
          case 1010130:
            tabId = 10
            break;
          case 101401:
            tabId = 15
            break;
          case 10601:
            tabId = 14
            break;
        }

        if (this.isCls.name == "classesId") {
          vm.right_list_disable = false;
          axios.get('/pmdm/admin/cls/getClassTableColumnInfo?clsId=' + this.isCls.val + "&tableId=" + res.id)
            .then((res) => {
              //console.log(res);
              if (res.data.code == 200) {
                vm.gridOptions.data = vm.getNewAdminP1Content(res);
              };
            })
            .catch(function (error) {
              console.log(error);
            });
        } else if (this.isCls.name == "subClsesId") {


          vm.right_list_disable = true;
          axios.get('/pmdm/admin/cls/getSubClassTableColumnInfo?subClsId=' + this.isCls.val + "&tableId=" + res.id)
            .then((res) => {
              // console.log(res);
              if (res.data.code == 200) {
                vm.gridOptions.data = vm.getNewAdminP1Content(res);
                // console.log(vm.gridOptions.data);
              };
            })
            .catch(function (error) {
              console.log(error);
            });
        };
      };
      if (name_ == this.$t('message.table.pageThree')) {
        vm.right_list_disable = false;
      };
    },

    dbClick(rowData) {
      //console.log(rowData);
      this.defaultValList = [];//先清空默认值的列表值，避免当前字段没有选择列表，默认值却有值的问题
      this.right_edit_info_data = [];
      this.pageListDataShow = true;
      this.cascadeMultiple = false;
      this.attributeInfo = rowData;
      this.editPageTitle = this.$t('message.table.title') + rowData.row.names;
      this.notSelect = false;
      var vm = this;
      if (this.isCls.name == "subClsesId") {
        axios.get('/pmdm/admin/cls/getSubClassAttributeProperties?subClsId=' + this.isCls.val + "&tableId=" + this.table_id + "&attributeId=" + rowData.row.id)
          .then((res) => {
            //console.log(res);
            if (res.data.code == 200) {
              vm.rightEditInfoDataDefaultValue(false, false, false, false);
              let editData = vm.getNewAdminP1EditData(res);
              //console.log(vm.right_edit_info_data);
              vm.right_edit_info_data = vm.getNewAdminP1EditContent(editData).val;
              vm.right_edit_info_data_old = vm.deepClone(vm.right_edit_info_data);
              vm.right_lists_disable = vm.getNewAdminP1EditContent(editData).readOnly;
              if (vm.right_edit_info_data[8] == "3") {
                vm.isSelectList = true;
                vm.getDefaultValList(vm.right_edit_info_data[7]);
                vm.rightEditInfoDataDefaultValue(false, true, false, false);
              } else if (vm.right_edit_info_data[8] == "4") {
                vm.isSelectList = true;
                vm.getDefaultValList(vm.right_edit_info_data[7]);
                vm.rightEditInfoDataDefaultValue(false, false, true, false);
              } else {
                vm.isSelectList = false;
                vm.rightEditInfoDataDefaultValue(true, false, false, false);
              };
              //console.log(vm.right_edit_info_data[5]);
              if (vm.right_edit_info_data[5] == "1") {
                vm.notSelect = true;
              } else {
                vm.notSelect = false;
              };

              let defaultDataVal = res.data.object.properties;//默认值没有则不展示默认值
              let defaultVal = false;
              defaultDataVal.map(item => {
                if (item.propertyType == 12 || this.centerTabId == "1010101") {
                  defaultVal = true;
                };
              });
              vm.noDefaultValue = defaultVal;
            };
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        axios.get('/pmdm/admin/cls/getClassAttributeProperties?clsId=' + this.isCls.val + "&tableId=" + this.table_id + "&attributeId=" + rowData.row.id)
          .then((res) => {
            //console.log(res);
            if (res.data.code == 200) {
              vm.rightEditInfoDataDefaultValue(false, false, false, false);
              let editData = vm.getNewAdminP1EditData(res);
              vm.right_edit_info_data = vm.getNewAdminP1EditContent(editData).val;
              vm.right_edit_info_data_old = vm.deepClone(vm.right_edit_info_data);
              vm.right_lists_disable = vm.getNewAdminP1EditContent(editData).readOnly;

              vm.rightEditInfoDataDefaultValue(false, true, false, false);
              if (vm.right_edit_info_data[8] == "3") {
                vm.isSelectList = true;
                vm.rightEditInfoDataDefaultValue(false, true, false, false);
                vm.getDefaultValList(vm.right_edit_info_data[7]);
              } else if (vm.right_edit_info_data[8] == "4") {
                vm.isSelectList = true;
                vm.rightEditInfoDataDefaultValue(false, false, true, false);
                vm.getDefaultValList(vm.right_edit_info_data[7]);
              } else {
                vm.isSelectList = false;
                vm.rightEditInfoDataDefaultValue(true, false, false, false);
              };
              console.log(vm.getNewAdminP1EditContent(editData));
              if (vm.right_edit_info_data[5] == "1") {
                vm.notSelect = true;
              } else {
                vm.notSelect = false;
              };

              let defaultDataVal = res.data.object.properties;//默认值没有则不展示默认值
              let defaultVal = false;
              defaultDataVal.map(item => {
                if (item.propertyType == 12 && this.centerTabId == "1010101") {
                  defaultVal = true;
                };
              });
              console.log(defaultVal);
              vm.noDefaultValue = defaultVal;
              // if(defaultVal == undefined){
              //   vm.noDefaultValue = true;
              // } else {
              //   vm.noDefaultValue = false;
              // };
              // let isList = res.data.object.properties;
              // for(let i = 0; i < isList.length; i++) {
              //   if (isList[i].propertyType == 7) {
              //     vm.isSelectList = true;
              //     break;
              //   } else {
              //     vm.isSelectList = false;
              //   };
              // };
            };
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    rightEditInfoDataDefaultValue(ipt, select, multiple, cas) {
      this.rightEditInfoDataInput = ipt;
      this.rightEditInfoDataSelect = select;
      this.rightEditInfoDataMultiple = multiple;
      this.cascade = cas;
    },
    getSelect(val) {
      this.getDefaultValList(val);
      //console.log(this.right_edit_info_data);
      if (this.right_edit_info_data[8] == 4) {
        this.right_edit_info_data[12] = [];
      } else {
        this.right_edit_info_data[12] = "";
      };
    },
    getDefaultValList(num) {
      let vm = this;
      //console.log(this.defaultValList);
      if (num == "") {
        return false
      };
      axios.get('pmdm/admin/list/retriveListEntries?listId=' + num)
        .then(res => {
          if (res.data.code == 200) {
            let arr = [];
            let lists = res.data.object;
            vm.cascadeMultiple = false;
            for (const key in lists) {
              if (key == -1) {
                lists[key] = lists[key].replace(/entryValue/g, 'label');
                lists[key] = lists[key].replace(/pid/g, 'value');
                let m = JSON.parse(lists[key])[0];
                // console.log(val_);
                // this.delChild(val_);
                this.del(m);
                arr = arr.concat(m);
                if (vm.right_edit_info_data[8] == 3) {
                  vm.rightEditInfoDataDefaultValue(false, false, false, true);
                  vm.cascadeMultiple = false;
                  vm.right_edit_info_data[12] = vm.right_edit_info_data[12].split(";");
                } else {
                  vm.rightEditInfoDataDefaultValue(false, false, false, false);
                  vm.cascadeMultiple = true;
                };
              } else {
                if (vm.right_edit_info_data[8] == 3) {
                  vm.rightEditInfoDataDefaultValue(false, true, false, false);
                } else if (vm.right_edit_info_data[8] == 4) {
                  vm.rightEditInfoDataDefaultValue(false, false, true, false);
                };
                let obj = {};
                obj.id = key;
                obj.name = lists[key];
                arr.push(obj);
              };
            };
            //console.log(arr);
            vm.defaultValList = arr;
          };
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editRightPage() {
      this.show_right_edit_info = false;
    },
    closePageInfoRight() {
      // this.show_right_edit_info = true;
      // this.show_right_edit_info = false;
      this.pageListDataShow = false;
      // console.log(this.right_edit_info_data[7]);
    },
    submitPageFormRight() {
      var submitData = this.contrastData(this.right_edit_info_data_old, this.right_edit_info_data);
      // console.log(this.right_edit_info_data);
      // console.log(this.right_edit_info_data_old);
      // console.log(submitData);

      this.right_edit_info_data[1] = this.right_edit_info_data[1].trim();
      if (!this.right_edit_info_data[1] || this.right_edit_info_data[1].match(/^[ ]*$/)) {
        this.$message.error(this.$t('message.error.name'));
        return false
      };

      var propsData = [];
      var vm = this;
      //console.log(submitData);
      if (JSON.stringify(submitData) !== "{}") {
        for (var key in submitData) {
          var obj = {};
          obj.propertyType = key;
          if (Array.isArray(submitData[key])) {
            let a = submitData[key].join(";");
            //console.log(a);
            if (a.length == 0) {
              obj.propertyValue = "";
            } else {
              obj.propertyValue = a;
            };
          } else {
            obj.propertyValue = submitData[key];
          };
          propsData.push(obj);
        };
        var subForm = {
          classId: this.isCls.val,
          tableId: this.table_id,
          attributeId: this.attributeInfo.row.id,
          props: propsData
        };
        ///console.log(subForm);
        axios.post('/pmdm/admin/cls/updateAttributeProperties', subForm)
          .then((res) => {
            if (res.data.code == 200) {
              vm.$message({
                type: 'success',
                message: res.data.message,
              });
              vm.pageListDataShow = false;
              vm.closePageInfoRight();
              vm.tab2Click(vm.right_tab_info, vm.num3);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    dialogClose() {
      this.show_right_edit_info = true;
    },
    addDialogClose() {
      this.addSubClsPage = false;
    },
    //生命周期阶段
    addDataEvent() {
      var vm = this;
      this.$refs.xGridLifecycle.insert({
        phaseName: "",
        description: "",
        enabled: 0,
        classId: this.isCls.val
      }).then(res => {
        this.$refs.xGridLifecycle.setActiveRow(res.row);
      });
    },

    refreshLazyTree(node) {//刷新懒加载树
      console.log(node);
      if (node) {
        node.loaded = false;
        node.loadData();
      } else {
        this.parentData.loaded = false;
        this.parentData.loadData();
      }
    },

    getUpdateEvent() {
      var vm = this;
      this.$refs.xGridLifecycle.validate(true).then(res => {
        if (!res) {
          var xGrid_ = this.$refs.xGridLifecycle;
          let updateRecords = this.$refs.xGridLifecycle.getUpdateRecords(); //获取修改的行
          // console.log(updateRecords);
          if (updateRecords.length !== 0) {//编辑
            var update = {
              updateLifecyclePhase: updateRecords
            };
            // console.log(update);
            axios.post('/pmdm/admin/lifecycle/update', update)
              .then((res) => {
                if (res.data.code == 200) {
                  //console.log(res);
                  vm.$message({
                    type: 'success',
                    message: res.data.message
                  });
                };
                vm.tabClick(vm.center_tabinfo, vm.num);
                // vm.tabsClick(vm.right_tabinfo, vm.num2);
              })
              .catch(function (error) {
                console.log(error);
              });
          };

          var insertList = this.$refs.xGridLifecycle.getInsertRecords();
          if (insertList.length !== 0) {
            for (var i = 0; i < insertList.length; i++) {
              delete insertList[i].id
            };
            var insert = {
              insertLifecyclePhase: insertList
            };
            //console.log(insertList);
            axios.post('/pmdm/admin/lifecycle/save', insert)
              .then((res) => {
                if (res.data.code == 200) {
                  // console.log(res);
                  vm.$message({
                    type: 'success',
                    message: res.data.message
                  });
                  vm.tabClick(vm.center_tabinfo, vm.num);
                  // vm.tabsClick(vm.right_tabinfo, vm.num2); right_tabinfo是右边的tab，lifecycle和右边的tab没有联动关系，所以不再执行
                };
              })
              .catch(function (error) {
                console.log(error);
              });
          };
        }
      });
    },
    closeSave() {
      this.gridLifecycle.data = this.deepClone(this.old_grid_data);
    },
    editDisabledEvent() { },
    noEdit() { },

  },
};
</script>

<style>
.left .el-tree-node:focus>.el-tree-node__content {
  background-color: #409EFF;
  color: #fff;
}

.left .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #409EFF;
  color: #fff;
}

.edit-right-data .el-dialog__body {
  padding-top: 0 !important;
}

.custom-tree-node .el-button--text {
  color: #000 !important;
}

.tabs-info .el-collapse-item__header {
  background: none;
  height: 38px;
  width: 16%;
  position: absolute;
  right: 0;
  top: 0;
}

.tabs-info .el-collapse-item__content {
  padding-bottom: 0;
}
</style>

<style scoped>
.btn {
  display: inline-block;
  padding: 4px;
  padding-right: 10px;
  border: 1px solid #000;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 8px;
  font-size: 14px;
}

.btn span {
  position: relative;
  padding: 0 2px;
}

.btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  font-size: 14px;
}

.btn img {
  height: 100%;
  width: 100%;
}

.btn1 {
  height: 32px;
  color: #4b92ff;
  border-color: rgba(75, 146, 255, 0.5);
  background: rgba(75, 146, 255, 0.2);
  margin-left: 20px;
}

.btn1:hover {
  color: #fff;
  background: rgba(75, 146, 255, 0.4);
}

.btn7 {
  height: 32px;
  color: #4b92ff;
  border-color: rgba(75, 146, 255, 0.5);
  background: rgba(75, 146, 255, 0.2);
}

.btn7:hover {
  color: #fff;
  background: rgba(75, 146, 255, 0.4);
}

.btn8 {
  height: 32px;
  color: #fe6263;
  border-color: rgba(254, 98, 99, 0.5);
  background: rgba(254, 98, 99, 0.2);
}

.btn8:hover {
  color: #fff;
  background: rgba(254, 98, 99, 0.4);
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

/* 右边页面 */
.right-title {
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  margin-left: 20px;
  height: 40px;
}

.right-title li {
  float: left;
  padding: 8px 8px 8px 8px;
  font-size: 14px;
  cursor: pointer;
  margin-right: 18px;
}

.right-title li:hover {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.right-title .active2 {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

/* 中间页面 */
.tabs-info {
  padding: 20px;
}

.tabs-info ul {
  padding: 0;
  margin-top: 0;
}

.tabs-info ul li {
  border: 1px solid blue;
  border-color: #61affe;
  background: rgba(97, 175, 254, .1);
  margin-bottom: 6px;
  overflow: hidden;
  position: relative;
}

.tabs-info ul li p {
  font-size: 14px;
  padding: 10px;
  margin: 0;
}

.liHover:hover {
  background: #5cb0f9;
  color: #fff;
  cursor: pointer;
}

.bomLists {
  padding: 8px 10px;
}

.bomLists:hover {
  background: #5cb0f9;
  color: #fff;
  cursor: pointer;
}

.tabs-info ul .visible {
  border: 1px solid #000;
  background: #f4f4f4;
}

.tabs-info ul .active2 {
  background: #5cb0f9;
  color: #fff;
}

.tabs-info .ep-collapse-item__arrow {
  flex: 1 0 auto;
  order: -1;
}

.table-list {
  margin-top: 6px;
}

.table-list li {
  overflow: hidden;
}

.table-list .list-key {
  display: inline-block;
  width: 42%;
  text-align: right;
  font-size: 14px;
}

.table-list .list-val {
  display: inline-block;
  width: 52%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  font-size: 14px;
  position: relative;
  top: 3px;
}

.table-list .list-key-1 {
  display: inline-block;
  width: 26%;
  text-align: right;
  font-size: 14px;
}

.line-1 {
  height: 780px;
  width: 2px;
  background: #ebebeb;
  float: left;
  overflow: hidden;
}

.content-title {
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  margin-left: 10px;
  height: 40px;
  width: 100%;
}

.content-title li {
  float: left;
  width: 23%;
  padding: 8px 8px 8px 8px;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 3px;
}

.content-title li:hover {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.content-title .active {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.left {
  height: 780px;
  width: 16%;
  background: #fff;
  float: left;
  overflow: auto;
  overflow-x: scroll;
}

.el-tree {
  min-width: 100%;
  display: inline-block !important;
}

.center {
  height: 780px;
  width: 25%;
  float: left;
  overflow: hidden;
}

.right {
  height: 780px;
  width: 58%;
  float: left;
  overflow: auto;
}
</style>
